import { Routes, Route } from 'react-router-dom';
import {
  LayoutDashboard, Building2, Users,
  Settings, MapPin, Palette, Share2, BookOpen, MessageSquareQuote, Bell,
} from 'lucide-react';
import PortalLayout, { type NavItem } from '../../components/PortalLayout';

import Dashboard from './Dashboard';
import Properties from '../Admin/Properties';
import Staff from '../Admin/Staff';
import Locations from '../Admin/Locations';
import Features from '../Admin/Features';
import StaffHandbooks from '../Admin/StaffHandbooks';
import Testimonials from '../Admin/Testimonials';
import Appearance from '../Admin/Appearance';
import Contact from './Contact';
import Estates from './Estates';
import NoticeBoard from '../Admin/NoticeBoard';
import Profile from '../../components/Profile';

const navItems: NavItem[] = [
  { to: '/it', label: 'Dashboard', icon: <LayoutDashboard className="h-5 w-5" />, end: true },
  { to: '/it/properties', label: 'Properties', icon: <Building2 className="h-5 w-5" /> },
  { to: '/it/staff', label: 'Staff & Users', icon: <Users className="h-5 w-5" /> },
  { to: '/it/estates', label: 'Estates', icon: <Building2 className="h-5 w-5" /> },
  { to: '/it/locations', label: 'States & Areas', icon: <MapPin className="h-5 w-5" /> },
  { to: '/it/features', label: 'Features', icon: <Settings className="h-5 w-5" /> },
  { to: '/it/staff-handbook', label: 'Staff Handbook', icon: <BookOpen className="h-5 w-5" /> },
  { to: '/it/testimonials', label: 'Testimonials', icon: <MessageSquareQuote className="h-5 w-5" /> },
  { to: '/it/appearance', label: 'Appearance', icon: <Palette className="h-5 w-5" /> },
  { to: '/it/contact', label: 'Contact & Socials', icon: <Share2 className="h-5 w-5" /> },
  { to: '/it/notices', label: 'Notices', icon: <Bell className="h-5 w-5" /> },
];

export default function Oversight() {
  return (
    <PortalLayout title="Oversight Portal" navItems={navItems}>
      <Routes>
        <Route index element={<Dashboard />} />
        <Route path="properties" element={<Properties />} />
        <Route path="staff" element={<Staff />} />
        <Route path="estates" element={<Estates />} />
        <Route path="locations" element={<Locations />} />
        <Route path="features" element={<Features />} />
        <Route path="staff-handbook" element={<StaffHandbooks />} />
        <Route path="testimonials" element={<Testimonials />} />
        <Route path="appearance" element={<Appearance />} />
        <Route path="contact" element={<Contact />} />
        <Route path="notices" element={<NoticeBoard />} />
        <Route path="profile" element={<Profile />} />
      </Routes>
    </PortalLayout>
  );
}
